import React from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

export function ConfirmDeleteModal({
  open,
  onClose,
  onConfirm,
  name,
  busy,
  title,
  description,
  confirmLabel,
  testId = "confirm-delete",
}) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent
        className="border-border-subtle bg-surface"
        data-testid={testId}
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-text-primary">
            <AlertTriangle className="h-5 w-5 text-status-unavailable" aria-hidden />
            {title || t("admin.common.delete_title")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-text-secondary">
            {description || t("admin.common.delete_body", { name })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid={`${testId}-cancel`}>
            {t("admin.common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={busy}
            data-testid={`${testId}-ok`}
            className="bg-status-unavailable text-white hover:bg-status-unavailable/90"
          >
            {confirmLabel || t("admin.common.delete_confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
